import { CampaignRunState } from "model/campaigns";

export enum CampaignStatusView {
  Draft = "draft",
  Running = "running",
  Finished = "finished",
  Paused = "paused",
}

export const VIEW_STATUS = {
  [CampaignRunState.Draft]: {
    status: CampaignStatusView.Draft,
    tooltip: "Lineitems or landings are missing in campaign",
  },
  [CampaignRunState.Finished]: {
    status: CampaignStatusView.Finished,
    tooltip: "All lineitems have finished",
  },
  [CampaignRunState.RunningButFinished]: {
    status: CampaignStatusView.Finished,
    tooltip: "Despite campaign running, all lineitems have finished",
  },
  [CampaignRunState.Running]: {
    status: CampaignStatusView.Running,
    tooltip: "Campaign has running lineitems",
  },
  [CampaignRunState.RunningButPaused]: {
    status: CampaignStatusView.Paused,
    tooltip: "Despite campaign running, all lineitems are paused",
  },
  [CampaignRunState.Paused]: {
    status: CampaignStatusView.Paused,
    tooltip: "Campaign is paused",
  },
};
